// Build-time app flavor. The same React app compiles into two Capacitor
// binaries; REACT_APP_NATIVE_APP (baked in at build) selects which shell
// App.js mounts. Unset/anything-but-portal => the POS app (unchanged default).
const raw = (process.env.REACT_APP_NATIVE_APP || 'pos').toLowerCase();
export const APP_FLAVOR = raw === 'portal' ? 'portal' : 'pos';
export const isPortalFlavor = APP_FLAVOR === 'portal';
const appFlavor = { APP_FLAVOR, isPortalFlavor };
export default appFlavor;
